import styled from 'styled-components'

export const Style = styled.div`
  margin-bottom: 200px;
  @media screen and (min-width: 768px) and (max-width: 1160px) {
    margin-bottom: 10px;
  }
  @media screen and (min-width: 300px) and (max-width: 768px) {
    /* display: none; */
    .card-image-box {
      padding: 0;
      box-shadow: none;
    }
    margin-bottom: 50px;
  }
  .bottom-margin-column {
    margin-bottom: 24px;
  }
  .bottom-margin {
    margin-bottom: 30px;
  }
`
